import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetch active shipping zones from backend
export async function fetchShippingConfig() {
  const res = await axios.get(`${API}/shipping/zones`);
  return res.data; // { zones, free_shipping_threshold, supported_countries }
}

// Given config + countryCode + subtotal, return shipping info
export function getShippingForCountry(config, countryCode, subtotal) {
  if (!config || !countryCode) return null;
  if (subtotal >= (config.free_shipping_threshold || 1000)) {
    return { cost: 0, etaMin: 2, etaMax: 7, label: "Free Shipping" };
  }
  const zone = (config.zones || []).find((z) => (z.country_codes || []).includes(countryCode));
  if (!zone) return null;
  return {
    cost: Number(zone.price_eur) || 0,
    etaMin: zone.eta_min_days || 2,
    etaMax: zone.eta_max_days || 7,
    label: zone.name,
  };
}

// Build flat list of {code, name, zone_name} from config, sorted by zone sort_order then name
export function getCountryListFromConfig(config) {
  if (!config) return [];
  const codeToName = {};
  (config.supported_countries || []).forEach((c) => { codeToName[c.code] = c.name; });
  const result = [];
  (config.zones || []).forEach((zone) => {
    (zone.country_codes || []).forEach((code) => {
      result.push({ code, name: codeToName[code] || code, zone: zone.name });
    });
  });
  return result;
}
